/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var RemoteJobStatus;
(function (RemoteJobStatus) {
    RemoteJobStatus["AVAILABLE"] = "AVAILABLE";
    RemoteJobStatus["QUEUED"] = "QUEUED";
    RemoteJobStatus["RUNNING"] = "RUNNING";
    RemoteJobStatus["UNAVAILABLE"] = "UNAVAILABLE";
})(RemoteJobStatus || (RemoteJobStatus = {}));
export function RemoteJobStatusFromJSON(json) {
    return RemoteJobStatusFromJSONTyped(json, false);
}
export function RemoteJobStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function RemoteJobStatusToJSON(value) {
    return value;
}
